import { gql } from '@apollo/client';

/**
 * Records the click and returns the actual join URL. The URL is NEVER exposed
 * in queries — only through this mutation (spec 0013). Operation names
 * intentionally differ from the backend fields.
 */
export const JoinLessonMutation = gql`
  mutation JoinLessonNow($groupLessonId: Int!) {
    lmsJoinLesson(groupLessonId: $groupLessonId) {
      success
      redirectUrl
      customErrors {
        field
        code
        message
      }
    }
  }
`;

export const SetTodayLinkMutation = gql`
  mutation PutTodayLessonLink($groupId: Int!, $joinUrl: String!) {
    lmsSetTodayLessonLink(groupId: $groupId, joinUrl: $joinUrl) {
      success
      customErrors {
        field
        code
        message
      }
    }
  }
`;

export const ClearTodayLinkMutation = gql`
  mutation DropTodayLessonLink($groupId: Int!) {
    lmsClearTodayLessonLink(groupId: $groupId) {
      success
      customErrors {
        field
        code
        message
      }
    }
  }
`;
